import styles from './alerts.scss';
import ReactHtmlParser from 'react-html-parser';
import CustomAnchorTag from '../CommonComponents/CustomAnchorTag/customAnchorTag';

export default class Alerts extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: 1,
            isDelayBillAlertsAdded: false,
            isServiceTriggered: false,
            dataUpdated: false,
        };
        this.RECORDS_PER_PAGE = 1;
        this.arrowActive = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/dss_green_chev.svg';
        this.arrowDisable = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/dss_grey_chev.svg';
        this.warningImg = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/dss_warning.svg';
        this.closeIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/dss_dismiss.svg';
    }
    /*To get Local Alerts */
    getLocalAlerts = () => {
        if(!this.state.isServiceTriggered) {
            this.setState({isServiceTriggered: true});
            app.contentService.getContent("LOCAL_ALERTS").then(
                (response) => {
                    let alertsObj = {}, alertInfo = [];
                    _.each(response, function (alerts) {
                        alertsObj["alertTitle"] = alerts.title;
                        alertsObj["alertMsg"] = alerts.body;
                        alertsObj["key"] = 1;
                        alertsObj["alertType"] = 'Local Alerts';
                        alertsObj["isDrupalLocalAlert"] = true;
                        if (!_.isEmpty(alertsObj)) {
                            alertInfo.push(alertsObj);
                            alertsObj = {};
                        }
                    });
                    let alertsArr = !_.isEmpty(app.appService.getSessionstorage('alertsInfoCheck')) && !_.isEmpty(app.appService.getSessionstorage('alertsInfo')) ? app.appService.getSessionstorage('alertsInfo') : [];
                    app.appService.setSessionstorage('alertsInfoCheck', 'ALERTS_LOCAL');
                    this.getAlertsInfo(alertsArr.concat(alertInfo));
                },
                (error) => {
                }
            );
        }
    }

    /*To get Delayed Billing */
    getDelayedBilling = () => {
        let alertMsg = {}, alertInfo = [];                
        let titleRgx = new RegExp('<p id="DELAY BILL_alertTitle">(.*?)</p>', 'g');
        let msgRgx = new RegExp('<p id="DELAY BILL_alertMsg">(.*?)</p>', 'g');
        let learnMoreRgx = new RegExp('<a id="delayBillLearnMore_lnkName" lnkpath="(.*?)">(.*?)</a>', 'g');
        let title = titleRgx.exec(this.props.alertsContent.body);
        let msg = msgRgx.exec(this.props.alertsContent.body);
        let learMore = learnMoreRgx.exec(this.props.alertsContent.body);
        alertMsg["alertTitle"] = title ? title[1] : "" ;
        alertMsg["alertMsg"] = msg ? msg[1] : "" ;
        alertMsg["key"] = 6;
        alertMsg["alertType"] = 'Local Alerts';
        alertMsg["learMoreLable"] = learMore ? ReactHtmlParser(learMore[2]) : "";
        alertMsg["learMoreLnk"] =  learMore ? learMore[1] : "";
        let isDelayedBilling = !this.props.isInactive && app.appService.getSessionstorage('isSingle') ? app.dashboardService.getDelayedBilling(this.props.lastBillEndDate): null;
        if (isDelayedBilling) {
            alertInfo.push(alertMsg);
            let alertsArr = !_.isEmpty(app.appService.getSessionstorage('alertsInfoCheck')) && !_.isEmpty(app.appService.getSessionstorage('alertsInfo')) ? app.appService.getSessionstorage('alertsInfo') : [];
            app.appService.setSessionstorage('alertsInfoCheck', 'ALERTS_DELAYED');
            app.appService.setSessionstorage('isDelayBillAlertsAdded', true);
            alertsArr = alertsArr.concat(alertInfo);
            this.sortAlertsInfo(alertsArr);
            this.setState({isDelayBillAlertsAdded: true});            
        }
    }

    /* validate flag to remove repeated alerts */
    validateAlertFlag(messageFlagData){
        let msgFlagData = messageFlagData;
        let priorAndPast = msgFlagData.includes("PRIOR DUE") && msgFlagData.includes("PAST DUE");
        let priorOrPast = msgFlagData.includes("PRIOR DUE") || msgFlagData.includes("PAST DUE");
        let flagArray = priorAndPast?["PRIOR DUE", "PAST DUE"]: msgFlagData.includes("PRIOR DUE")? ["PRIOR DUE"]:["PAST DUE"];
        if((priorAndPast||priorOrPast) && msgFlagData.includes("SERV DISC")){
            flagArray.forEach(flag =>{
            msgFlagData.splice(msgFlagData.findIndex(item => item === flag), 1);
        });}
        else if((priorAndPast||priorOrPast) && this.props.customerAccountStatus==="Pending Disconnect"){
            flagArray.forEach(flag =>{
            msgFlagData.splice(msgFlagData.findIndex(item => item === flag), 1);});
            !msgFlagData.includes("PEND DISC")?msgFlagData.push("PEND DISC"):null;}
        else if(priorAndPast){
            let pastFlag = "PAST DUE";
            msgFlagData.splice(msgFlagData.findIndex(item => item === pastFlag), 1);}
        if(this.props.customerAccountStatus==="Pending Disconnect"){
            !msgFlagData.includes("PEND DISC")?msgFlagData.push("PEND DISC"):null;}
        return msgFlagData;
    }
    /*To get Alert associated and arrange them in array of object format along with alertTitle, alertMsg and key */
    getAlertsInfo = (alertsArr) => {
        let alertsObj = {};
        let alertInfo = [];
        if (!_.isEmpty(this.props.messageFlagData) && !_.isEmpty(this.props.alertsContent)) {
            let alertsContent = this.props.alertsContent;
            let alertFlagData = this.props.messageFlagData;
            let messageFlagData = this.validateAlertFlag(this.props.messageFlagData);
            _.each(messageFlagData, function (eachMessageFlag) {
                let alertCode = eachMessageFlag.toString().trim();                
                let titleRgx = new RegExp('<p id="'+alertCode+'_alertTitle">(.*?)</p>', 'g');
                let msgRgx = new RegExp('<p id="'+alertCode+'_alertMsg">(.*?)</p>', 'g');
                switch (alertCode) {
                    case "LPP":
                        if(alertFlagData.includes('LPP') && alertFlagData.includes('DP'))
                        {
                            null;
                        }
                        else
                        {
                        alertsObj["alertTitle"] = alertsContent.body.match(titleRgx);
                        alertsObj["alertMsg"] = alertsContent.body.match(msgRgx);
                        alertsObj["key"] = 9;
                        alertsObj["alertType"] = 'Local Alerts';
                        }
                        break;
                    case "LPP-PEND DP":
                        alertsObj["alertTitle"] = alertsContent.body.match(titleRgx);
                        alertsObj["alertMsg"] = alertsContent.body.match(msgRgx);
                        alertsObj["key"] = 7;
                        alertsObj["alertType"] = 'Local Alerts';
                        break;
                    case "PEND DISC":
                        alertsObj["alertTitle"] = alertsContent.body.match(titleRgx);
                        alertsObj["alertMsg"] = alertsContent.body.match(msgRgx);
                        alertsObj["key"] = 5;
                        alertsObj["alertType"] = 'Local Alerts';
                        break;
                    case "PAST DUE":
                        alertsObj["alertTitle"] = alertsContent.body.match(titleRgx);
                        alertsObj["alertMsg"] = alertsContent.body.match(msgRgx);
                        alertsObj["key"] = 4;
                        alertsObj["alertType"] = 'Local Alerts';
                        break;
                    case "PRIOR DUE":
                        alertsObj["alertTitle"] = alertsContent.body.match(titleRgx);
                        alertsObj["alertMsg"] = alertsContent.body.match(msgRgx);
                        alertsObj["key"] = 3;
                        alertsObj["alertType"] = 'Local Alerts';
                        break;
                    case "SERV DISC":
                        alertsObj["alertTitle"] = alertsContent.body.match(titleRgx);
                        alertsObj["alertMsg"] = alertsContent.body.match(msgRgx);
                        alertsObj["key"] = 2;
                        alertsObj["alertType"] = 'Local Alerts';
                        break;
                    case "PYMT AGMT":
                        alertsObj["alertTitle"] = alertsContent.body.match(titleRgx);
                        alertsObj["alertMsg"] = alertsContent.body.match(msgRgx);
                        alertsObj["key"] = 8;
                        alertsObj["alertType"] = 'Local Alerts';
                        break;
                    // case "DP":
                    //     alertsObj["alertTitle"] = alertsContent.body.match(titleRgx);
                    //     alertsObj["alertMsg"] = alertsContent.body.match(msgRgx);
                    //     alertsObj["key"] = 10;
                    //     alertsObj["alertType"] = 'Local Alerts';
                    //     break;

                    // case "DP-PEND":
                    //     alertsObj["alertTitle"] = alertsContent.body.match(titleRgx);
                    //     alertsObj["alertMsg"] = alertsContent.body.match(msgRgx);
                    //     alertsObj["key"] = 11;
                    //     alertsObj["alertType"] = 'Local Alerts';
                    //     break;

                }
                if (!_.isEmpty(alertsObj)) {
                    alertInfo.push(alertsObj);
                    alertsObj = {};
                }
            });
        }
        app.appService.setSessionstorage('alertsInfoCheck', 'ALERTS_BILL');
        let concatArray = alertsArr.concat(alertInfo);
        !_.isEmpty(alertInfo) || !_.isEmpty(alertsArr) ? this.sortAlertsInfo(concatArray) : null;
    }
    /*To sort alerts info based on key value */
    sortAlertsInfo = (data) => {
        let sortedArr = data.sort(function (a, b) {
            return a.key - b.key;
        });
        app.appService.setSessionstorage('alertsInfo', sortedArr);
        this.setState({dataUpdated: true});
    }

    DelayedBillingLearnMore = (link) =>{
        let events = {
            alertDismissed:false, alertInteracted:false, manageAccount:false, makePayment:false, autoPayEnroll:false, paperlessEnroll:false, viewBill:false, viewUsage:false, custom:false, autopayCancel:false, paperlessCancel:false, sdpEnroll:false, sepEnroll:false, savingsPlan:false, paymentArrangement:false,componentClick:true,componentName:'Alert section'
        };
        app.analyticsService.addPageLevelData('eventCapturing', events);
        window.aUtils ? window.aUtils.sendAAEvent("button", "dashboard|none|none|alert_section|page|delayedBilling_LearnMore") : null;
        app.appUtil.navigateInNewTab(link);
    }    
    /*To navigate previous page */
    prevPage = () => {
        if (this.state.currentPage !== this.RECORDS_PER_PAGE) {
            let events = {
                alertDismissed:false, alertInteracted:true, manageAccount:false, makePayment:false, autoPayEnroll:false, paperlessEnroll:false, viewBill:false, viewUsage:false, custom:false, autopayCancel:false, paperlessCancel:false, sdpEnroll:false, sepEnroll:false, savingsPlan:false, paymentArrangement:false,componentClick:true,componentName:'Alert section'
            };
            app.analyticsService.addPageLevelData('eventCapturing', events);
            window.aUtils ? window.aUtils.sendAAEvent("button", "dashboard|none|none|alert_section|page|previous") : null;
            this.setState({ currentPage: this.state.currentPage - 1 });
        }
    }
    /*To navigate next page */
    nextPage = (NO_OF_PAGES) => {
        if (this.state.currentPage !== NO_OF_PAGES) {
            let events = {
            alertDismissed:false, alertInteracted:true, manageAccount:false, makePayment:false, autoPayEnroll:false, paperlessEnroll:false, viewBill:false, viewUsage:false, custom:false, autopayCancel:false, paperlessCancel:false, sdpEnroll:false, sepEnroll:false, savingsPlan:false, paymentArrangement:false,componentClick:true,componentName:'Alert section'
            };
            app.analyticsService.addPageLevelData('eventCapturing', events);
            window.aUtils ? window.aUtils.sendAAEvent("button", "dashboard|none|none|alert_section|page|next") : null;
            this.setState({ currentPage: this.state.currentPage + 1 });
        }
    }
    /*on click of dismiss link, remove respective alert and update the sorted array */
    removeAlert = (data) => {
        let events = {
            alertDismissed:true, alertInteracted:false, manageAccount:false, makePayment:false, autoPayEnroll:false, paperlessEnroll:false, viewBill:false, viewUsage:false, custom:false, autopayCancel:false, paperlessCancel:false, sdpEnroll:false, sepEnroll:false, savingsPlan:false, paymentArrangement:false,componentClick:true,componentName:'Alert section'
        };
        app.analyticsService.addPageLevelData('eventCapturing', events);
        window.aUtils ? window.aUtils.sendAAEvent("button", "dashboard|none|none|alert_section|page|dismiss") : null;
        let records = data;
        records.splice(this.state.currentPage - 1, 1);
        app.appService.setSessionstorage('alertsInfo', records);
        this.state.currentPage > 1 ? this.setState({ currentPage: this.state.currentPage - 1 }) : this.setState({ currentPage: 1 });
    }
    /*To show pagination section */
    showPagination = (NO_OF_PAGES, isMobile,alertsInfo) => {
        return (
            <div className={styles.sce_paginationDiv}>  
            {  
                 NO_OF_PAGES > 1 ?               
                    <span>
                        <button onClick={this.prevPage} id='sceAlertPreviousBtn' className={styles.sceBtnOutline}> <img src={this.state.currentPage===1?this.arrowDisable:this.arrowActive} className={styles.rotateIconLeft} alt='left arrow' /> </button>
                        <span className={styles.billingAlertsPaginationCurrPage}> {` ${this.state.currentPage} of ${NO_OF_PAGES} `} </span>
                        <button onClick={() => this.nextPage(NO_OF_PAGES)} id='sceAlertNextBtn' className={styles.sceBtnOutlineBorder}> <img src={this.state.currentPage===NO_OF_PAGES?this.arrowDisable:this.arrowActive} className={styles.rotateIconRight} alt="right arrow" /> </button>
                    </span> : null
            }

            </div>
        );
    }

    /*To show Alerts enrolled */    
    showAlertEnrolled = (records, NO_OF_PAGES, isMobile, alertsInfo) => {
        return (
            records.length > 0 ?
                records.map((alerts, index) => (
                    <div className={[styles.sceAlertSec, (NO_OF_PAGES===1?styles.sceOneAlert:styles.sceMultipleAlerts)].join(" ")}>
                        <div className={styles.sceAlertFullWidth}>
                            <img src={this.warningImg} className={isMobile ? ['col-xs-1 col-sm-1', styles.waringImgMbAlign].join(" ") : ['col-xs-1 col-sm-1', styles.waringImgAlign].join(" ")} alt='warning img' />
                            <div className={['col-xs-10 col-sm-11', styles.alertDisplayAlign].join(" ")}>
                                {/* <p className={styles.sceAlertsTitle} id='alertName' name={ReactHtmlParser(alerts.alertTitle)}> {ReactHtmlParser(alerts.alertTitle)} </p>
                                <div> {ReactHtmlParser(alerts.alertMsg)} {alerts.learMoreLable?<CustomAnchorTag id="custId" linkName={alerts.learMoreLable} onClick={()=>this.DelayedBillingLearnMore(alerts.learMoreLnk)} isUnderline />:null} </div> */}
                                <div className={styles.sceAlertContent}> <span className={styles.sceAlertsTitle} id='alertName' name={ReactHtmlParser(alerts.alertTitle)}> {ReactHtmlParser(alerts.alertTitle)}: </span> {ReactHtmlParser(alerts.alertMsg)} {alerts.learMoreLable?<CustomAnchorTag id="custId" linkName={alerts.learMoreLable} onClick={()=>this.DelayedBillingLearnMore(alerts.learMoreLnk)} isUnderline />:null} </div>
                            </div>
                        </div>
                        {app.appService.setSessionstorage('alert_type', alerts.alertType)}
                        <div className={styles.sce_customATagDismiss}><img src={this.closeIcon}  alt='close icon'  onClick={() => this.removeAlert(alertsInfo)} /></div>  
                    </div>
                )) : null

        );
    }

    getEligibleAlerts = (alertsInfo) => {
        return alertsInfo.filter((eachAlert)=>{
            return eachAlert.isDrupalLocalAlert;
        });
    }

    getAlertsSection = (isMobile) => {
        let alertsInfo = app.appService.getSessionstorage('alertsInfo');
        let alertsInfoCheck = app.appService.getSessionstorage('alertsInfoCheck');
        let records =  null, numberOfPages = null, showAlertSection = null, elgibleAlertsList = [];
        
        if(!_.isEmpty(alertsInfoCheck)) {
            if(!_.isEmpty(alertsInfo)) {
                elgibleAlertsList = !this.props.isDrupalOnlyAlerts ? alertsInfo : this.getEligibleAlerts(alertsInfo);
                if(!_.isEmpty(elgibleAlertsList)) {
                    records = elgibleAlertsList.slice(this.state.currentPage - 1, this.state.currentPage);
                    numberOfPages = Math.ceil(elgibleAlertsList.length / this.RECORDS_PER_PAGE);
                    showAlertSection = records.length !== 0 ? <div className={styles.sceAlertContainer}><div className={[styles.billingAlertSection, 'row'].join(" ")}><div className={'col-xs-12 '+styles.alertTextAlign}><div className={styles.alertTextAlign}><div className={styles.sceAlertBox}>{this.showAlertEnrolled(records, numberOfPages, isMobile, alertsInfo)} <div className={numberOfPages>1?styles.sceHorizontalBar:styles.displayNone} /> {numberOfPages>1?this.showPagination(numberOfPages, isMobile,alertsInfo):null} </div></div></div></div></div> : null;
                }
            }
        }
        return showAlertSection;
    }
    
    render() {
        const isMobile = app.appUtil.detectMobile();
        let getAlertInfo = !_.isEmpty(app.appService.getSessionstorage('alertsInfo') && app.appService.getSessionstorage('alertsInfoCheck')) ? null : this.getLocalAlerts();
        this.props.lastBillEndDate && !app.appService.getSessionstorage('isDelayBillAlertsAdded') ? this.getDelayedBilling() : null;
        let showAlertSection = this.getAlertsSection(isMobile);
        return (
            /*<div id="alert_section"... is added to track Page Break. Please don't remove it.*/
            <div id='alert_section'>{showAlertSection}</div>
        );
    }
}
